export { TITLE } from './constants'
export type { TGraduateProfessionsProps } from './types'
export { getGraduateProfessionsData } from './api'
